exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\n    position: relative;\n    min-height: calc(100% - 82px);\n    margin: 16px;\n}\n", ""]);

// exports
